import { useContext } from 'react';
import { VdpCardType } from '~/constants/home/VdpCardType';
import GlobalContext from '~/context/home/GlobalContext';
import RecentlyViewed from './RecentlyViewed';
import RecentSearches from './RecentSearches';
import SuggestedForYou from './SuggestedForYou';

const TopCarousels = () => {
  const { vdpCardTypeShown } = useContext(GlobalContext);
  const isRecentlyViewedInVdpLinks = vdpCardTypeShown === VdpCardType.Recent;

  return (
    <>
      {isRecentlyViewedInVdpLinks ? (
        <>
          <SuggestedForYou />
          <RecentlyViewed />
        </>
      ) : (
        <>
          <RecentlyViewed />
          <SuggestedForYou />
        </>
      )}
      <RecentSearches />
    </>
  );
};

export default TopCarousels;
